import Vue from 'vue';
import axios from 'axios';
import Vuelidate from 'vuelidate';
import ButtonSpinner from './button-spinner.vue';
import { xhrRequestConfig, getFooterNewsletterEndpointUrl } from '../utils/api.js';
import { required, email } from 'vuelidate/lib/validators';

Vue.use(Vuelidate);

const FOOTER_NEWSLETTER_ENDPOINT = getFooterNewsletterEndpointUrl();

export default {
    components: {
        ButtonSpinner
    },

    data() {
        return {
            email: null,
            submitting: false,
            submitted: false
        }
    },

    validations() {
        return {
            email: {
                required,
                email
            }
        }
    },

    methods: {
        _validation() {        
            this.$v.$touch();
            return !this.$v.$error;
        },

        submitFooterNewsletter() {
            this.submitting = true;
            if (this._validation()) {
                let formData = {
                    'email': this.email
                };

                return axios.post(FOOTER_NEWSLETTER_ENDPOINT, formData, xhrRequestConfig).then(async (response) => {
                    // console.log("??", response.data);
                    this.submitting = false;
                    this.submitted = true;
                }).catch((error) => {
                    console.log(error);
                    return error;
                })
            } else {
                this.submitting = false;
            }
        }
    }
}